export default __webpack_public_path__ + "static/media/fad-undo.09ad82fa.svg";